import { frontendURL } from 'dashboard/helper/URLHelper';
import QualificaAIPage from './QualificaAIPage.vue';
import { CAMPAIGN_PERMISSIONS } from 'dashboard/constants/permissions.js';
export const publicRoutes = [];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/qualifica-ai'),
    name: 'qualifica_ai',
    meta: {
      permissions: ['administrator', CAMPAIGN_PERMISSIONS],
    },
    component: QualificaAIPage,
  },
];
